export default "__VITE_ASSET__CKWrRpks__"